module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marker-edit"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.$route.meta.existingMarker) ? _c('h2', {
    staticClass: "feature"
  }, [_vm._v(_vm._s(_vm.$t("marker.edit")))]) : _c('h2', {
    staticClass: "feature"
  }, [_vm._v(_vm._s(_vm.$t("marker.create")))])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("marker.name")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('marker.placeholder.name'),
        maxlength: 32,
        name: 'name',
        required: true,
        rows: 1,
        autofocus: true,
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.name),
      callback: function($$v) {
        _vm.$set(_vm.marker, "name", $$v)
      },
      expression: "marker.name"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("marker.description")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('marker.placeholder.description'),
        maxlength: 55,
        name: 'description',
        required: true,
        rows: 2,
        autofocus: false,
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.description),
      callback: function($$v) {
        _vm.$set(_vm.marker, "description", $$v)
      },
      expression: "marker.description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("marker.long_description")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('marker.placeholder.long_description'),
        maxlength: 600,
        name: 'long_description',
        required: true,
        rows: 3,
        autofocus: false,
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.long_description),
      callback: function($$v) {
        _vm.$set(_vm.marker, "long_description", $$v)
      },
      expression: "marker.long_description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "locale-selection"
  }, _vm._l((_vm.locales), function(l) {
    return _c('a', {
      class: {
        'selected': l === _vm.currentEditLocale
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.currentEditLocale = l
        }
      }
    }, [(l == "en") ? _c('span', [_vm._v(_vm._s(l) + " (default)")]) : _c('span', [_vm._v(_vm._s(l))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ml_keyword"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('marker.placeholder.ml_keyword')) + "\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marker.ml_keyword),
      expression: "marker.ml_keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ml_keyword",
      "id": "ml_keyword",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.marker.ml_keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.marker, "ml_keyword", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ml_keyword"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('marker.targeted_user_groups')) + "\n          ")]), _vm._v(" "), (_vm.groups) ? _c('group-selector', {
    attrs: {
      "groups": _vm.groups
    },
    model: {
      value: (_vm.marker.targeted_groups),
      callback: function($$v) {
        _vm.$set(_vm.marker, "targeted_groups", $$v)
      },
      expression: "marker.targeted_groups"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brands.length > 1),
      expression: "brands.length > 1"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('brand-selector', {
    staticClass: "brand-selection",
    attrs: {
      "brands": _vm.brands
    },
    model: {
      value: (_vm.marker.brand),
      callback: function($$v) {
        _vm.$set(_vm.marker, "brand", $$v)
      },
      expression: "marker.brand"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-container flex-stretch flex-reverse-wrap"
  }, [_c('div', {
    staticClass: "col-md-7 col-xs-12",
    attrs: {
      "id": "location-time-container"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('marker.location')) + " "), _c('small', {
    staticClass: "smaller"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.edit = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('marker.edit_on_map')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input-places', {
    attrs: {
      "position": _vm.position,
      "attrs": {
        id: 'input-places',
        placeholder: _vm.$t('marker.placeholder.address'),
        disabled: _vm.disabled
      }
    },
    on: {
      "place-selected": _vm.updateMarkerPosition
    }
  }, [_c('label', {
    attrs: {
      "slot": "before",
      "for": "input-places"
    },
    slot: "before"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('marker.address')) + " "), _c('small', {
    staticClass: "optional"
  }, [_vm._v(_vm._s(_vm.$t("optional")))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "radius"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("marker.radius")) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.$t("marker.meters")) + ")")])]), _vm._v(" "), _c('input-number', {
    attrs: {
      "id": "radius",
      "increment-by": "100",
      "max-value": _vm.maxRadius,
      "min-value": "50",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.marker.radius),
      callback: function($$v) {
        _vm.$set(_vm.marker, "radius", $$v)
      },
      expression: "marker.radius"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("marker.time")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startsat"
    }
  }, [_vm._v(_vm._s(_vm.$t("marker.start_date")))]), _vm._v(" "), _c('input-datetime', {
    attrs: {
      "attrs": {
        id: 'startsat',
        placeholder: 'Starts on',
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.starts_at),
      callback: function($$v) {
        _vm.$set(_vm.marker, "starts_at", $$v)
      },
      expression: "marker.starts_at"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "endsat"
    }
  }, [_vm._v(_vm._s(_vm.$t("marker.end_date")))]), _vm._v(" "), _c('input-datetime', {
    attrs: {
      "attrs": {
        id: 'endsat',
        placeholder: 'Ends on',
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.ends_at),
      callback: function($$v) {
        _vm.$set(_vm.marker, "ends_at", $$v)
      },
      expression: "marker.ends_at"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 flex-container flex-stretch",
    attrs: {
      "id": "map-preview-container"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.edit = true
      }
    }
  }, [_c('map-preview', {
    staticStyle: {
      "flex": "1",
      "position": "relative"
    },
    attrs: {
      "position": _vm.position
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startsInTheFuture),
      expression: "startsInTheFuture"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "revealAtChoice"
    }
  }, [_vm._v(_vm._s(_vm.$t("marker.reveal_at")))]), _vm._v(" "), _c('input-reveal-at', {
    model: {
      value: (_vm.revealAtChoice),
      callback: function($$v) {
        _vm.revealAtChoice = $$v
      },
      expression: "revealAtChoice"
    }
  })], 1)]), _vm._v(" "), (!_vm.existingMarker) ? _c('div', {
    staticClass: "row"
  }, [_c('duration-helper', {
    attrs: {
      "start": _vm.marker.starts_at,
      "end": _vm.marker.ends_at
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("marker.additional_settings")))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marker.is_push_forced),
      expression: "marker.is_push_forced"
    }],
    attrs: {
      "type": "checkbox",
      "id": "force-push",
      "name": "force-push"
    },
    domProps: {
      "checked": Array.isArray(_vm.marker.is_push_forced) ? _vm._i(_vm.marker.is_push_forced, null) > -1 : (_vm.marker.is_push_forced)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.marker.is_push_forced,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.marker, "is_push_forced", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.marker, "is_push_forced", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.marker, "is_push_forced", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "force-push"
    }
  }, [_vm._v("Send notifications to all users in selected groups")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    staticClass: " glyphicon glyphicon-info-sign",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), _c('span', [_vm._v("indepent of location - if no group is selected, all users will be notified")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-full-width",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled || _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-indicator",
    staticStyle: {
      "margin-top": "16px"
    }
  })])])]), _vm._v(" "), (_vm.edit) ? _c('map-editor', {
    attrs: {
      "transition": "modal",
      "position": _vm.position,
      "max-radius": _vm.maxRadius,
      "attrs": {
        'placeholder': _vm.$t('marker.placeholder.address_search')
      }
    },
    on: {
      "position-changed": _vm.updateMarkerPosition,
      "close": function($event) {
        _vm.edit = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a9904c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarkerEdit.vue
// module id = 1046
// module chunks = 1